export default {
  paper: {
    width: '1680px',
  },
};
